import { render, staticRenderFns } from "./Terrain.vue?vue&type=template&id=1cfae76c&scoped=true&lang=pug&"
import script from "./Terrain.ts?vue&type=script&lang=ts&"
export * from "./Terrain.ts?vue&type=script&lang=ts&"
import style0 from "./Terrain.vue?vue&type=style&index=0&id=1cfae76c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfae76c",
  null
  
)

export default component.exports